<button
  mat-button
  type="button"
  class="pending-action-button"
  aria-label="Enviar proposta do fornecedor"
  (click)="handleClick()">
  <mat-icon class="pending-action-button-icon" aria-hidden="true">upload</mat-icon>
  Enviar proposta
</button>
